<span
  class="pi pi-bell"
  tabindex="0"
  title="Notifications"
  (click)="showNotification()"
  (keydown)="showNotification()"
></span>
